<template>
  <div>
    <div>
      <h1>Liste des actes personnels</h1>
      <h2>Recherche</h2>

      <!-- Barre de recherche -->
      <div>
        <div @click="toggleFilter">
          <span>Voir tout</span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M7 10l5 5 5-5z"/>
          </svg>
        </div>
        <div>
          <svg width="21" height="21" viewBox="0 0 24 24" fill="none">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/>
          </svg>
          <input
            v-model="searchQuery"
            type="text"
            placeholder="Recherche"
          />
        </div>
      </div>

      <!-- Liste des actes -->
      <div>
        <ul>
          <li
            v-for="acte in filteredActes"
            :key="acte.id"
          >
            <button
              type="button"
              :aria-label="acte.favori ? 'Retirer des favoris' : 'Ajouter aux favoris'"
              :aria-pressed="acte.favori"
              @click="toggleFavori(acte)"
            >
              <svg width="19" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
            </button>
            <span>{{ acte.code }}</span>
            <span>{{ acte.libelle }}</span>
            <span>{{ acte.tarif }}</span>
          </li>
        </ul>
      </div>

      <!-- Pied : Annuler / Ok -->
      <div>
        <button type="button" @click="annuler">Annuler</button>
        <button type="button" @click="valider">Ok</button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RechercheActes',

  data() {
    return {
      searchQuery: '',
      filterOpen: false,
      actes: [
        { id: 1, code: 'APC', libelle: 'Avis Ponctuel de Consultant du Médecin', tarif: '55,00€', favori: false },
        { id: 2, code: 'APU', libelle: 'Avis Ponctuel de Consultant du Médecin', tarif: '69,00€', favori: false },
        { id: 3, code: 'APV', libelle: 'Avis Ponctuel de Consultant du Médecin en Visite', tarif: '55,00€', favori: false },
        { id: 4, code: 'ASE', libelle: 'Consultation Aide Sociale Enfance', tarif: '46,00€', favori: false },
        { id: 5, code: 'BTC', libelle: 'Bilan Mission Retrouve Ton Cap', tarif: '80,00€', favori: false },
        { id: 6, code: 'C', libelle: 'Consultation', tarif: '23,00€', favori: false },
        { id: 7, code: 'CA', libelle: 'Consultation Approfondie', tarif: '26,00€', favori: false },
        { id: 8, code: 'CCP', libelle: 'Consultation Prévention Santé Sexuelle', tarif: '46,00€', favori: false },
        { id: 9, code: 'CN', libelle: 'Consultation', tarif: '22,00€', favori: false },
      ],
    };
  },

  computed: {
    filteredActes() {
      const q = this.searchQuery.trim().toLowerCase();
      if (!q) return this.actes;
      return this.actes.filter(
        (a) =>
          a.code.toLowerCase().includes(q) ||
          a.libelle.toLowerCase().includes(q) ||
          a.tarif.replace(',', '.').includes(q)
      );
    },
  },

  methods: {
    toggleFilter() {
      this.filterOpen = !this.filterOpen;
    },
    toggleFavori(acte) {
      acte.favori = !acte.favori;
    },
    annuler() {
      this.$emit('cancel');
    },
    valider() {
      this.$emit('ok');
    },
  },
});
</script>

